import { Injectable } from '@angular/core';
import { ACCESS_ERROR_CODE } from './user-access.service';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
  ) { }

  public showError(err: ACCESS_ERROR_CODE) {
    switch (err) {
      case ACCESS_ERROR_CODE.INVALID_CODE:
        alert('El código introducido no es correcto');
        break;
      case ACCESS_ERROR_CODE.INVALID_LOGIN:
        alert('El usuario no existe o la contraseña es incorrecta');
        break;
      case ACCESS_ERROR_CODE.NO_PERMISSION:
        alert('No tiene permiso para ver este Book Digital. Por favor, contacte con su centro');
        break;
      case ACCESS_ERROR_CODE.CONNECTION_ERROR:
      default:
        alert('Ha ocurrido un error de conexión. Por favor, inténtelo de nuevo');
        break;
    }
  }

  public parseDate(date: string): string | null {
    let splitted, d, m, y;
    if (new RegExp('^(\\d{4})-((0[1-9])|(1[0-2])|[1-9])-([1-9]|([0-2][0-9])|(30|31))$').test(date)) {
      splitted = date.split('-').map(c => +c);
      y = splitted[0]
      m = (splitted[1] < 10) ? '0' + splitted[1] : splitted[1]
      d = (splitted[2] < 10) ? '0' + splitted[2] : splitted[2]
    } else
      if (new RegExp('^([1-9]|([0-2][0-9])|(30|31))-((0[1-9])|(1[0-2])|[0-9])-(\\d{4})$').test(date)) {
        splitted = date.split('-').map(c => +c);
        y = splitted[2]
        m = (splitted[1] < 10) ? '0' + splitted[1] : splitted[1]
        d = (splitted[0] < 10) ? '0' + splitted[0] : splitted[0]
      } else
        if (new RegExp('^([1-9]|([0-2][0-9])|(30|31))\\/((0[1-9])|(1[0-2])|[0-9])\\/(\\d{4})$').test(date)) {
          splitted = date.split('/').map(c => +c);
          y = splitted[2]
          m = (splitted[1] < 10) ? '0' + splitted[1] : splitted[1]
          d = (splitted[0] < 10) ? '0' + splitted[0] : splitted[0]
        } else {
          alert('La fecha introducida no es válida. Por favor, introduzca la fecha con el formato dd/mm/aaaa. Por ejemplo: 30/12/1999');
          return null;
        }

    return `${y}${m}${d}`;
  }
}
